import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, timer } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { environment } from './../../../environments/environment';
import { AuthenticationService, LoginState } from './authentication.service';
import { CmsService } from './cms.service';
import { LogCategory, LogCoreService, LoggerService, LogType } from './logger.service';

@Injectable({
    providedIn: 'root'
})
export class AlertService {

    public polledAlerts$: Observable<any> = null;
    private alerts: any[];

    constructor(
        private http: HttpClient,
        private logger: LoggerService,
        private auth: AuthenticationService,
        private cmsService: CmsService,
    ) {
        this.log("constructor", null, LogCategory.Constructor);
                
        let AlertPollingFrequency = environment.alertPollingFrequency;

        // Only poll alerts while the user is logged in. Re-poll every xx milliseconds(xx=AlertPollingFrequency), after 2 second.
        this.polledAlerts$ = timer(2000, AlertPollingFrequency).pipe(
            filter(() => ((auth.loginState >= LoginState.loggedin)) && (auth.loginState <= LoginState.spoofing_refreshable) ),
            switchMap(() => this.getAlerts()),
            tap((data) => this.log("constructor", "Poll alert", LogCategory.SubscriptionData ) )
            );
    }

    private getAlerts(): Observable<any> {
        var alertsRequest = this.http.get<any>(environment.apiUrl + '/announcements/alerts');
        var cmsAlertsRequest = this.cmsService.getV2ContentByType$("Alerts");
        return forkJoin(alertsRequest, cmsAlertsRequest).pipe(map(([alerts, cmsalerts]) => { return alerts.concat(cmsalerts) }));
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.CoreService, LogCoreService.Alert, category);
    }
}
